/**
 * "Messages, 3 waiting" (25 Oct 2026, D-1025-NAV): what waits in the Messages page — replies and bounces in Incoming plus
 * emails queued in Outgoing. The two reads are the page's own (src/lib/messages.ts), so they share its cache and the server
 * has already narrowed them to the role (the scheduler: Housekeeping only, D-1024-MESSAGES). Only the roles that may open
 * /messages ask at all.
 */
import type { Role } from '@shared/roles';
import { useInbox, useMessages } from '@/lib/messages';
import { ROUTE_ROLES } from './nav';

export function useMessagesWaiting(role: Role | null): number {
  const on = !!role && ROUTE_ROLES['/messages']!.includes(role);
  const inbox = useInbox(on);
  const queued = useMessages('queued', on);
  if (!on) return 0;
  return (inbox.data?.count ?? 0) + (queued.data?.counts?.queued ?? 0);
}
